import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Clock, Eye } from 'lucide-react';
export function SemaforoProtocol() {
  const steps = [{
    color: 'bg-red-500',
    lightColor: 'bg-red-500/10',
    borderColor: 'border-red-500/30',
    textColor: 'text-red-500',
    title: 'ROJO',
    action: 'ACTUÁ YA',
    icon: <AlertTriangle size={32} data-id="element-353" />,
    desc: 'Emergencia inminente. Instrucciones directas para estabilizar antes de correr a la guardia.'
  }, {
    color: 'bg-yellow-500',
    lightColor: 'bg-yellow-500/10',
    borderColor: 'border-yellow-500/30',
    textColor: 'text-yellow-500',
    title: 'AMARILLO',
    action: 'ESTABILIZÁ Y CONSULTÁ',
    icon: <Clock size={32} data-id="element-354" />,
    desc: 'Situación de riesgo. Qué hacer en casa mientras contactás a tu veterinario.'
  }, {
    color: 'bg-green-500',
    lightColor: 'bg-green-500/10',
    borderColor: 'border-green-500/30',
    textColor: 'text-green-500',
    title: 'VERDE',
    action: 'MONITOREÁ',
    icon: <Eye size={32} data-id="element-355" />,
    desc: 'Síntomas leves. Qué observar y cuándo preocuparse realmente.'
  }];
  return <section className="py-8 md:py-14 px-4 bg-neutral-900 relative overflow-hidden" data-id="element-356">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-lg h-full bg-brand/5 blur-[100px] rounded-full pointer-events-none" data-id="element-357" />

      <div className="container mx-auto max-w-5xl relative z-10" data-id="element-358">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-359">
          <h2 className="text-3xl md:text-7xl font-display text-white mb-4" data-id="element-360">
            El Protocolo Semáforo de{' '}
            <span className="text-brand" data-id="element-361">60 Segundos</span>
          </h2>
          <p className="text-lg md:text-xl text-neutral-300 max-w-3xl mx-auto leading-relaxed" data-id="element-362">
            He diseñado un sistema visual y ultra-rápido que te permite
            diagnosticar la gravedad de tu gato en un minuto. Sin términos
            técnicos, sin vueltas. Es como tener a un veterinario de confianza
            susurrándote al oído qué hacer mientras mantenés la calma.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-363">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className={`rounded-2xl border ${step.borderColor} ${step.lightColor} p-8 relative overflow-hidden group`} data-id="element-364">
              {/* Traffic light circle indicator */}
              <div className={`absolute top-6 right-6 w-4 h-4 rounded-full ${step.color} shadow-[0_0_15px_currentColor]`} data-id="element-365" />

              <div className={`${step.textColor} mb-4`} data-id="element-366">{step.icon}</div>

              <h3 className={`text-3xl font-display ${step.textColor} mb-1`} data-id="element-367">
                {step.title}
              </h3>
              <div className="text-white font-bold text-xl mb-4 tracking-wide" data-id="element-368">
                {step.action}
              </div>
              <p className="text-neutral-300 leading-relaxed" data-id="element-369">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}